import { Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { dotPath, isNilOrEmpty } from 'ramdasauce'
import cn from 'classnames'

import { useStyles } from './styles'
import { Text } from 'components/atoms'
import { ROUTES } from 'utils/constants'

export const VideoTile = ({ data, altStyles }) => {
  const classes = useStyles()

  const textBlockClasses = cn({
    [classes.textBlock]: true,
    [classes.altBlock]: altStyles,
  })

  return (
    <Link
      to={`${ROUTES.EPISODE}${dotPath('urlSlug.current', data)}`}
      className={classes.wrapper}
    >
      {!isNilOrEmpty(dotPath('thumbnail', data)) && (
        <GatsbyImage
          image={getImage(dotPath('thumbnail.asset', data))}
          alt={dotPath('title', data)}
          className={classes.thumbnail}
        />
      )}
      <div className={textBlockClasses}>
        <Text tag="p" size="body7" className={classes.category}>
          {dotPath('category', data)}
        </Text>
        <Text tag="h3" size="body9" className={classes.title}>
          {dotPath('title', data)}
        </Text>
        <Text tag="h3" size="body4" className={classes.interviewee}>
          {dotPath('interviewee', data)}
        </Text>
      </div>
    </Link>
  )
}
